import axios from 'axios';
import { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
// import { useNavigate } from 'react-router-dom';

const ResetTwoFaAction = (props: any) => {
    const token = useParams().token;
    console.log('ResetTwoFaAction token:', token);
    const reset2FaToken = async () => {
        const reset2FaLink = `${process.env.REACT_APP_COMMON_API}/email/reset-2fa`;
        axios
            .post(reset2FaLink, {
                token: token,
            })
            .then((res: any) => {
                console.log(res.data);
                console.log(res.data.message);
                Swal.fire({
                    icon: res.data.success ? 'success' : 'error',
                    title: res.data.success ? 'Success' : 'Error',
                    text: res.data.message,
                }).then(() => {
                    // retiurn to logiin screen
                    // window.location.reload();
                    // navigate to login page
                    window.location.href = `/management/${res.data.data.schoolDomain}/login`;
                });
            });
    };
    useEffect(() => {
        reset2FaToken();
    }, []);

    return (
        <>
            <div className="reset-2fa-action-container"></div>
        </>
    );
};

export default ResetTwoFaAction;
